import React from "react";

const SearchScreen = () => {
  return (
    <div style={styles.container}>
      <h1>Coming soon SearchScreen</h1>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    fontSize: "24px",
  },
};

export default SearchScreen;
